import axios from 'axios';

export default {
  state: {
    counterPushData: {},
    counterBasketData: {},
    counterFavoriteData: {},
    counterData: {},
    counter_loading: false,
    counter_error: null,
    counter_loaded: false
  },
  mutations: {
    SET_COUNTER_DATA(state, data) {
      state.counterData = data;
      state.counterBasketData = data.basket;
      state.counterFavoriteData = data.favorite;
      state.counterPushData = data.push;
      state.loaded = true;
    },
    SET_LOADING(state, status) {
      state.counter_loading = status;
    },
    SET_ERROR(state, error) {
      state.counter_error = error;
    },
    RESET_LOADED_STATE(state) {
      state.counter_loaded = false;
    },
    ADD_FAVORITE(state, id) {
      state.counterFavoriteData.ids.push(id);
    },
    ADD_BASKET(state, id) {
      if (!state.counterBasketData.ids.includes(id))
      state.counterBasketData.ids.push(id);
    },
    REMOVE_FAVORITE(state, id) {
      state.counterFavoriteData.ids = state.counterFavoriteData.ids.filter(item => item !== id);
    }
  },
  actions: {
    async fetchCounterData({ commit, state }, update=false) {
      // Skip fetching if data is already loaded
      if (update!== true && state.loaded && state.counterData) {
        return;
      }

      try {
        //commit('SET_LOADING', true);
        const response = await axios.get('/api/counter/');

        if (response.data && response.data.data) {
          commit('SET_COUNTER_DATA', response.data.data);
        } else {
          throw new Error('Invalid data format received from API');
        }

        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message || 'Ошибка при загрузке данных');
        console.error('Error fetching main page data:', error);
      } finally {
        //commit('SET_LOADING', false);
      }
    },

    // Force refresh method (optional) if you need to manually refresh the data
    async refreshCounterData({ commit, dispatch }) {
      commit('SET_LOADING', true);
      commit('SET_COUNTER_DATA', null);
      commit('SET_ERROR', null);
      commit('RESET_LOADED_STATE');
      await dispatch('fetchCounterData');
    }
  },
  getters: {
    counterData: state => state.counterData,
    counterBasketData: state => state.counterBasketData,
    counterFavoriteData: state => state.counterFavoriteData,
    counterPushData: state => state.counterPushData,
    counterLoading: state => state.counter_loading,
    counterError: state => state.counter_error,
    counterLoaded: state => state.counter_loaded
  }
}
